import { FC, ReactElement, ReactNode } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { LoaderIndicator } from 'tedooo-web-design-system/ui';

import { isEmptyArray } from '../../utils';

export interface IInfiniteScroller {
  loadMore(): void;
  scrollableTarget?: string;
  totalCount: number;
  emptyState?: ReactElement;
  hasMore: boolean;
  list: any[] | null;
  children: ReactNode;
}

const InfiniteScroller: FC<IInfiniteScroller> = ({
  children,
  list,
  totalCount,
  hasMore,
  loadMore,
  emptyState = null,
}) => {
  if (!list) {
    return null;
  }

  if (isEmptyArray(list)) {
    return emptyState;
  }

  return (
    <InfiniteScroll
      next={loadMore}
      scrollableTarget="shop-page"
      hasMore={hasMore}
      loader={<LoaderIndicator size={10} />}
      dataLength={totalCount}
    >
      {children}
    </InfiniteScroll>
  );
};

export default InfiniteScroller;
